exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".provider-options {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.provider-options.providers-2 {\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.provider-options.providers-2 .provider {\n  width: 200px;\n  margin: 20px;\n}\n.provider-options .provider {\n  width: 166px;\n  margin: 10px;\n}\n.provider-options .provider .panel-heading {\n  padding: 10px 0;\n}\n.provider-options .provider-selection-logo {\n  width: 100%;\n}\n.provider-options .provider-selection-logo h4 {\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  min-height: 70px;\n  height: 100%;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/cloudProvider/providerSelection/providerSelection.modal.less
// module id = 2846
// module chunks = 0